import { memo } from "react";
import { View } from "react-native";
import Animated from "react-native-reanimated";
import useRenderGatheringHeaderWheelItem from "src/components/GatheringHeader/hooks/useRenderGatheringHeaderWheelItem";
import { GatheringHeaderProps } from "src/components/GatheringHeader/types";
import Wheel from "src/components/Wheel";
import useDim from "src/hooks/useDim";
import GatheringHeaderThumbnailImage from "../../../GatheringHeaderThumbnailImage";
import GatheringHeaderRegularParallaxWrapper from "./components/GatheringHeaderRegularParallaxWrapper/GatheringHeaderRegularParallaxWrapper";
import GatheringHeaderRegularThumbnailGradient from "./components/GatheringHeaderRegularThumbnailGradient";

const GatheringHeaderRegularThumbnail = ({
	wheelData,
	renderWheelItem,
	thumbnailUrl_1x1,
	wheelDataLoading,
	renderThumbnailOverlay,
	regularOptions: { scrollOffset, autoPlay = true } = {},
}: Pick<
	GatheringHeaderProps,
	| "wheelData"
	| "renderWheelItem"
	| "thumbnailUrl_1x1"
	| "wheelDataLoading"
	| "regularOptions"
	| "renderThumbnailOverlay"
>) => {
	const { height } = useDim({
		staticDim: true,
	});
	const fullHeight = 0.6 * height;
	const clippedHeight = 0.4 * height;
	const { renderItem } = useRenderGatheringHeaderWheelItem({
		renderWheelItem,
		wheelDataLoading,
	});

	return (
		<Animated.View
			style={{
				width: "100%",
				height: clippedHeight,
				overflow: "visible",
			}}
		>
			<View
				style={{
					width: "100%",
					height: fullHeight,
					top: -0.2 * fullHeight,
					position: "absolute",
					overflow: "hidden",
					alignItems: "center",
				}}
			>
				<GatheringHeaderRegularParallaxWrapper
					scrollOffset={scrollOffset}
					clippedHeight={clippedHeight}
				>
					<Wheel
						size={fullHeight}
						data={wheelData}
						renderItem={renderItem}
						autoRotateConfig={autoPlay ? undefined : false}
					>
						<GatheringHeaderThumbnailImage thumbnailUrl_1x1={thumbnailUrl_1x1} />
						{renderThumbnailOverlay?.()}
					</Wheel>
				</GatheringHeaderRegularParallaxWrapper>
				{/* We want this to underlay other components*/}
				<GatheringHeaderRegularThumbnailGradient
					direction="BottomUp"
					height={0.2 * height}
				/>
			</View>
		</Animated.View>
	);
};
export default memo(GatheringHeaderRegularThumbnail);
